import styled, { css } from 'styled-components';

export const baseContainer = css`
	max-width: 1160px;
	margin-left: auto;
	margin-right: auto;
`;

export const deskContainer = css`
	@media (max-width: 1180px) {
		max-width: initial;
		padding-left: 25px;
		padding-right: 25px;
	}
`;

export const mobileContainer = css`
	@media (max-width: 768px) {
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export const mpContainer = css`
	${baseContainer}
	${deskContainer}
	${mobileContainer}
`;

const Container = styled.div`
	${mpContainer}
`;

export default Container;
